import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_ECONSENT_URL,
  headers: {
    'Api-Key': process.env.REACT_APP_ECONSENT_API_KEY,
  },
});

export default api;